// extracted by mini-css-extract-plugin
export var animationContainer = "_gp-0";
export var asteriskIcon = "_gp-8";
export var conversationLeftSection = "_gp-4";
export var conversationListItem = "_gp-3";
export var conversationMiddleSection = "_gp-5";
export var conversationRightSection = "_gp-6";
export var detailsContent = "_gp-1";
export var listContainer = "_gp-7";
export var modalContent = "_gp-2";